import { useState } from 'react';
import { Button, Modal, Row, Typography } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import classes from './ReportGenerationWarningModal.module.scss';

type WarningModalPropsType = {
  isModalOpen: boolean;
  closeModal: () => void;
  warnings: string[];
};

const handleWarnings = ([warnings]: string[]) => {
  const epics = warnings.match(/'(.+?)'/);

  return epics ? epics[1]?.split(',') : epics;
};

export const ReportGenerationWarningModal = ({
  isModalOpen,
  closeModal,
  warnings,
}: WarningModalPropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.project' });

  const [areEpicsCopied, setEpicsCopied] = useState(false);

  const copyEpicsToClipBoard = () => {
    navigator.clipboard.writeText(handleWarnings(warnings)?.join(',') ?? '');
    setEpicsCopied(true);
  };

  return (
    <Modal
      title={t('warningModalTitle')}
      visible={isModalOpen}
      destroyOnClose={true}
      onCancel={closeModal}
      width={485}
      footer={
        <Row className={classes.warningModalControls} justify="end">
          <Button
            type="default"
            className="me-1"
            icon={areEpicsCopied ? <CheckOutlined /> : <CopyOutlined />}
            size="large"
            onClick={copyEpicsToClipBoard}
          >
            {areEpicsCopied ? 'Copied' : 'Copy'}
          </Button>
          <Button key="ok" type="primary" size="large" onClick={closeModal}>
            {t('okBtn')}
          </Button>
        </Row>
      }
    >
      {warnings.length ? (
        <>
          <Typography.Paragraph>
            The following epics are not taken into account when forming the report:
          </Typography.Paragraph>
          <div className="mt-1">
            {handleWarnings(warnings)?.map((warning: string) => (
              <Typography.Paragraph key={warning} className={classNames('mt-1', 'ms-2')}>
                - {warning}
              </Typography.Paragraph>
            ))}
          </div>
          <Typography.Paragraph className="mt-3">
            Please add epics to the Project Constructor if they should be considered in the report
          </Typography.Paragraph>
        </>
      ) : null}
    </Modal>
  );
};
